import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule, Routes } from '@angular/router';
import { SharedModule } from '../shared/shared.module';
import { ButtonsModule } from '@progress/kendo-angular-buttons';
import { NonAuthenticatedComponent } from './non-authenticated.component';

const authRoutes: Routes = [
  {
    path: '',
    component: NonAuthenticatedComponent,
    title: 'Login.ButtonText',
    children: [
      {
        path: '',
        loadChildren: () =>
          import('./features/login/login.module').then((m) => m.LoginModule),
      },
      {
        path: 'reset-password',
        loadChildren: () =>
          import('./features/reset-password/reset-password.module').then(
            (m) => m.ResetPasswordModule,
          ),
      },
    ],
  },
];

@NgModule({
  declarations: [NonAuthenticatedComponent],
  imports: [
    CommonModule,
    RouterModule.forChild(authRoutes),
    SharedModule,
    ButtonsModule,
  ],
  exports: [],
})
export class NonAuthenticatedModule {}
